
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/external-experts/chatgpt",
      function () {
        return require("private-next-pages/docs/external-experts/chatgpt.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/external-experts/chatgpt"])
      });
    }
  